export default __webpack_public_path__ + "static/bm-e2aa572a02963b087e48158ff3de2fcc.svg";